import { useQuery } from "@tanstack/react-query";
import { useSession } from "../auth-client";
import * as analyticsContextApi from "../api/analytics-context";

export const ANALYTICS_CONTEXT_QUERY_KEY = "analytics-context";

export function useAnalyticsContext(userId?: string) {
  const { data: session } = useSession();
  const authenticatedUserId = userId ?? session?.user?.id;
  return useQuery({
    queryKey: [ANALYTICS_CONTEXT_QUERY_KEY, authenticatedUserId],
    queryFn: analyticsContextApi.getAnalyticsContext,
    enabled: Boolean(authenticatedUserId),
    staleTime: 60_000,
    retry: false,
  });
}
